import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getMessaging, type Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Check if Firebase is properly configured (not using placeholder values)
const isFirebaseConfigured = () => {
  const requiredKeys = ['apiKey', 'projectId', 'appId'] as const;
  return requiredKeys.every((key) => {
    const value = firebaseConfig[key];
    return value && value !== 'placeholder' && value.length > 10;
  });
};

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

if (isFirebaseConfigured()) {
  try {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  } catch (e) {
    if (import.meta.env.DEV) {
      console.debug('[Firebase] Messaging not available:', (e as Error).message);
    }
  }
} else if (import.meta.env.DEV) {
  console.debug(
    '[Firebase] Push notifications disabled: Firebase credentials not configured'
  );
}

export { app, messaging };
